<template>
  <div>
    <div class="c-searchKeyword">
      <b-field class="c-searchKeywordContents">
        <b-input
          type="search"
          size="is-medium"
          placeholder="どのような仕事・相談をお探しですか？"
          :value="attributes.keyword"
          expanded
          @change.native="changeKeyword"
          @keydown.enter.native="searchKeyword"
          @compositionstart.native="composing=true"
          @compositionend.native="composing=false"
          v-model="attributes.keyword"
        />
        <div class="control" v-if="isPC">
          <c-button
            size="medium"
            color="secondary"
            isOutlined
            iconName="search"
            @click.native="searchKeyword"
          />
        </div>
      </b-field>
      <div class="c-searchKeywordDescription">
        <div class="flexItem flexItemExample">検索例) ホームページ制作 デザイン</div>
        <div class="flexItem flexItemHelp">
          初めて利用する方は
          <a href="" target="_blank">こちら</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// vuex
import { mapGetters } from 'vuex'

export default {
  name: 'SearchKeyword',
  props: {
    keyword: {
      type: String
    }
  },
  data() {
    return {
      attributes: {
        keyword: this.keyword
      },
      composing: false
    }
  },
  watch: {
    keyword(to) {
      this.attributes.keyword = to
    }
  },
  methods: {
    searchKeyword() {
      if (this.composing) return // IME確定時のenterでは検索しない
      this.$emit('search', this.attributes)
    },
    changeKeyword() {
      this.$emit('change', this.attributes)
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC'])
  }
}
</script>
<style lang="scss" scoped>
.c-searchKeyword {
  background: $color-gray-50;
  padding: 28px 24px 0;

  &Contents {
    margin: 0 auto;
    max-width: 680px;
  }

  &Description {
    margin: 0 auto;
    max-width: 680px;
    display: flex;
    justify-content: space-between;
    padding: 8px 0 8px;

    .flexItem {
      font-size: 12px;

      &Example {
      }

      &Help {
        text-align: right;
      }
    }
  }
}
</style>
